import { BoxProps, Flex } from '@chakra-ui/react'

import { PropsWithChildrenRequired } from 'constants/typings'

export const Tag = ({
  children,
  ...props
}: PropsWithChildrenRequired<BoxProps>) => (
  <Flex
    display="inline-flex"
    borderRadius="5px"
    border="1px solid"
    borderColor="brand.ultramarine"
    bgColor="brand.white"
    color="brand.ultramarine"
    fontSize="13px"
    fontWeight="600"
    px="12px"
    {...props}
  >
    {children}
  </Flex>
)
